
















import { ClientRoutes } from "@/data/enums/router";

export default {
  name: "ClientHeader",
  components: {
    "brand-logo": () => import("@/components/app/global/brand/logo.vue")
  },
  data() {
    return {
      clientDashboardRoute: { name: ClientRoutes.DASHBOARD }
    };
  }
};
